// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"Alert_confirmButton__csy2G","cancelButton":"Alert_cancelButton__h7IqS","htmlContainer":"Alert_htmlContainer__v7Yyl"};